export const ActionTypes = {
  LOADING: "CHANGE_USER_PROFILE_LOADING",
  ERROR: "CHANGE_USER_PROFILE_ERROR",
  SUCCESS: "CHANGE_USER_PROFILE_SUCCESS",
};
